const langLabels = {
  downloadCenter: {
    username: '用户名'
  }
}
export default langLabels
